import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type ConfirmDialogProps = {
	open: boolean;
	title: string;
	description: string;
	confirmLabel: string;
	confirmColor?: 'primary' | 'error' | 'success';
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const ConfirmDialog = ({
	open,
	title,
	description,
	confirmLabel,
	confirmColor = 'primary',
	loading = false,
	onClose,
	onConfirm,
}: ConfirmDialogProps) => {
	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<DialogContentText>{description}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" color="secondary" onClick={onClose} disabled={loading}>
					Annuler
				</Button>
				<Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={loading}>
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmDialog;
